<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 48 48"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.1056 4.21115C23.6686 3.92962 24.3314 3.92962 24.8944 4.21115L40.8944 12.2111C41.572 12.5499 42 13.2425 42 14V34C42 34.7575 41.572 35.4501 40.8944 35.7889L24.8944 43.7889C24.3314 44.0704 23.6686 44.0704 23.1056 43.7889L7.10557 35.7889C6.428 35.4501 6 34.7575 6 34V14C6 13.2425 6.428 12.5499 7.10557 12.2111L23.1056 4.21115ZM10 17.2361V32.7639L22 38.7639V23.2361L10 17.2361ZM26 23.2361V38.7639L38 32.7639V17.2361L26 23.2361ZM35.5279 14L24 19.7639L12.4721 14L24 8.23607L35.5279 14Z"
    />
  </svg>

</template>

<script lang="ts">
export default {
  name: "IconCube",
  props: ["height", "width"],
}
</script>
